import { RetroTemplate } from './types';
import { RETRO_TEMPLATES, RETRO_TEMPLATE_IDS } from './templateDefinitions';

const byId = new Map<string, RetroTemplate>(
  RETRO_TEMPLATES.map(t => [t.id, t]),
);

export function getTemplate(id: string | null | undefined): RetroTemplate | null {
  if (!id) return null;
  return byId.get(id) ?? null;
}

export function isValidTemplateId(id: string | null | undefined): boolean {
  if (!id) return true;
  return RETRO_TEMPLATE_IDS.includes(id);
}
